import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const GreetingRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.sizing.scale800};
  margin-bottom: ${({ theme }) => theme.sizing.scale900};

  ${media.mobile} {
    flex-direction: column;
    gap: ${({ theme }) => theme.sizing.scale600};
    margin-bottom: ${({ theme }) => theme.sizing.scale700};
  }
`;

export const GreetingBlock = styled.div`
  flex-shrink: 0;
`;

export const GreetingText = styled.h1`
  font-size: 36px;
  font-weight: 700;
  line-height: 44px;
  color: ${({ theme }) => theme.colors['neutral-90']};
  margin: 0;

  ${media.mobile} {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const DateText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin: 4px 0 0;
`;

export const FactCard = styled.div`
  border: 2px solid ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 12px;
  padding: 16px 20px;
  max-width: 420px;
  min-width: 280px;
  background: ${({ theme }) => theme.colors['neutral-0']};

  ${media.mobile} {
    max-width: 100%;
    min-width: 0;
  }
`;

export const FactLabel = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin-bottom: 6px;
`;

export const FactText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors['neutral-90']};
  margin: 0;
`;

export const SectionLabel = styled.h2`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin: 0 0 ${({ theme }) => theme.sizing.scale600};
`;

export const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.sizing.scale600};

  ${media.notDesktop} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${media.mobile} {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const ServiceCard = styled.div<{ $accentColor: string }>`
  border: 2px solid ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 12px;
  padding: 24px;
  background: ${({ theme }) => theme.colors['neutral-0']};
  cursor: pointer;
  transition:
    border-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1),
    box-shadow 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  color: inherit;
  display: block;

  &:hover {
    border-color: ${({ $accentColor }) => $accentColor};
    box-shadow: 0 4px 16px ${({ $accentColor }) => `${$accentColor}14`};
  }
  &:active {
    border-color: ${({ $accentColor }) => $accentColor};
    box-shadow: 0 2px 8px ${({ $accentColor }) => `${$accentColor}20`};
  }

  ${media.mobile} {
    padding: 16px;
  }
`;

export const ServiceIconWrapper = styled.div<{ $color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${({ $color }) => `${$color}14`};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $color }) => $color};
  margin-bottom: 12px;
`;

export const ServiceName = styled.span`
  display: block;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors['neutral-90']};
  margin-bottom: 4px;
`;

export const ServiceDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin: 0;
`;
